/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react'
// import * as H from 'history';
import { AnnouncementController } from '../controllers/AnnouncementController'
import { ISupportSpinner } from '../shared/Ajax'

export interface AnnouncementPageProps {
    // history: H.History
    // location: H.Location
}

export interface AnnouncementPageState {
    loginInProgress: boolean
    announcementTextHtml: string
}

export class Announcement extends React.Component<AnnouncementPageProps, AnnouncementPageState> implements ISupportSpinner {
  ajax: AnnouncementController

  constructor(props: AnnouncementPageProps) {
    super(props)

    this.ajax = new AnnouncementController();

    this.state = {
      loginInProgress: false,
      announcementTextHtml: '',
    }
  }

  componentDidMount() {
    this.ajax.getLoginPageAnnouncement(null, d => {
      this.setState({ announcementTextHtml: d })
    })
  }

  toggleSpinner(on: boolean, callback: { (): any }) {
    this.setState({ loginInProgress: on }, callback)
  }

  render() {
    return <div className="container-fluid pt-3">
      <div dangerouslySetInnerHTML={{ __html: this.state.announcementTextHtml }} />
    </div>
  }
}
